import A11yDialog from 'a11y-dialog';

const modals = {
  _scrollPosition: 0,
  _onOpenModal: function(dialog, event) {
    this._scrollPosition = window.scrollY;
    document.body.classList.add('modal-open');
    window.scrollTo(0, this._scrollPosition);
  },
  _onCloseModal: function(dialog, event) {
    document.body.classList.remove('modal-open');
    window.scrollTo(0, this._scrollPosition);
  },

  /**
   * Create new modal.
   *
   * @param {HTMLElement} el Modal container element.
   * @return {A11yDialog} Created modal instance.
   */
  createModal: function(el) {
    if (!el || !(el instanceof HTMLElement)) {
      return false;
    }

    const modal = new A11yDialog(el);
    modal.on('show', this._onOpenModal.bind(this));
    modal.on('hide', this._onCloseModal.bind(this));

    const showModal = (e) => {
      e.preventDefault();
      modal.show();
    };
    const links = el.id ? document.querySelectorAll('[href="#' + el.id + '"]') : [];
    links.forEach(link => {
      link.addEventListener('click', showModal);
    });

    return modal;
  },
};

export default modals;
